import { ChangeDetectorRef, Component, Input, ViewChild } from "@angular/core";
import { EditableGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/editable-grid/editable-grid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { RowAccess } from "projects/sepidz-web-framework/src/lib/models/row-access.model";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
@Component({
  selector: "row-access",
  templateUrl: "row-access.component.html",
  styleUrls: ["row-access.component.scss"],
})
export class RowAccessComponent extends BaseFormComponent<RowAccess> {
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  @ViewChild(EditableGridComponent) grid: EditableGridComponent;
  @Input() RowKindId: number;
  @Input() SelectedRows: number[];
  dataList: RowAccess[];
  entityList: RowAccess[];
  async ngOnInit() {
    this.apiName = "RowAccess";
    this.label = this.translate("ClientApp.GNR.RowAccess.RowAccess");
    super.ngOnInit();
    this.populateData();
  }
  addControl() {
    this.cd.markForCheck();
  }
  async populateData() {
    let filters: GridFilter[] = [];
    filters.push({ Filed: "RowKindId", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: this.RowKindId, Logic: "and" });
    filters.push({ Filed: "Rowids", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: this.SelectedRows, Logic: "and" });
    await this.httpCommonService
      .GetFilterGrid<any>("RowAccess/GetByRowKindIdRowIds", filters)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (x) => {
          if (x) {
            this.entityList = x;
            this.dataList = [];
            x.forEach((d) => {
              if (!this.dataList.some((s) => s.UserId === d.UserId)) this.dataList.push(d);
            });
            this.cd.markForCheck();
          }
        },
        (error) => {
          console.log("GridError");
        }
      );
  }
  valueChanges($event: any) {
    if ($event["DisplayName"] && $event["UserName"]) {
      if (this.grid.formGroup.controls["UserName"]) this.grid.formGroup.controls["UserName"].setValue($event["DisplayName"]);
      if (this.grid.formGroup.controls["FirstName"]) this.grid.formGroup.controls["FirstName"].setValue($event["FirstName"]);
      if (this.grid.formGroup.controls["LastName"]) this.grid.formGroup.controls["LastName"].setValue($event["LastName"]);
      if (this.grid.formGroup.controls["Active"]) this.grid.formGroup.controls["Active"].setValue(true);
    }
  }
  public async save() {
    if (this.grid.dataList && this.grid.dataList.length > 0) {
      this.grid.dataList.forEach((x) => {
        this.SelectedRows.forEach((sr) => {
          if (x.State !== RowState.Delete && !this.entityList.some((s) => s.UserId === x.UserId && s.RowKindId === this.RowKindId && s.RowId === sr))
            this.entityList.push({
              State: RowState.New,
              FirstName: x.FirstName,
              Id: x.Id,
              LastName: x.LastName,
              RowId: sr,
              RowKindId: this.RowKindId,
              UserId: x.UserId,
              Active: x.Active,
              UserName: x.UserName,
            });
          else if (x.State === RowState.Delete) {
            let temp = this.entityList.find((f) => f.UserId === x.UserId && f.RowId === sr);
            if (temp) temp.State = x.State;
          }
        });
      });
    }
    if (this.entityList.length > 0) {
      await this.httpCommonService
        .create("RowAccess/UpdateRowAccess", this.entityList)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (row) => this.saveSuccessHelper(row),
          (error) => this.saveFailedHelper(error)
        );
    }
  }
}
